import {loadFileByFileId, loadFileList} from "@/components/xmFileComCtl/server/fileServer";
import {isNullOrUnDef, StorageUtils} from "xmgoing-utils";
import {GoingNewUtils} from "xmgoing-utils";
import GoingUtils from "@/utils/goingUtils";
import {reactive, ref, unref, watch} from "vue";
import {LoadingOutlined} from "@ant-design/icons-vue";
import {getParamsStr} from "@/views/dataEmployeesDes/utils/ConditionNodeUtils";
interface IUpload{
  params?:any,
  imgUrl?:any,
  emits:any;
  fileUrl?:string,
  importParams?:any,
  businessId:Ref<string>;
  uploadAction?:Ref<string>;
}
export function useFileUploadHooks({params,importParams,emits,businessId,fileUrl,uploadAction,imgUrl}:IUpload,initFileRecord=(res)=>{}){
  //附件上传的参数
  const dataUpload:any = reactive({});
  const uploadFileFlag=ref(false);
  const loadingFlag=ref(false);
  const indicator = h(LoadingOutlined, {
    style: {
      fontSize: '24px',
    },
    spin: true,
  });

  let loadTimer:any=null;
  const fileList:any=ref([]);

  const addImgUrlToList=function () {
    if(unref(imgUrl).indexOf("/showImg")>=0||unref(imgUrl).indexOf("/download")>=0){
      unref(fileList).push({url:unref(imgUrl)})
    }else{
      unref(fileList).push({url:`/api/pe-attachment/attachment/showImg/` + unref(imgUrl)})
    }
  }

  //如果存在imgUrl
  if(unref(imgUrl)){
    addImgUrlToList();
  }

  //如果存在url
  if(unref(fileUrl)){
    const fileAry=(unref(fileUrl)+'').split("/");
    const fileId=fileAry[fileAry.length-1];
    if(fileId){
      loadFileByFileId(fileId,(res)=>{
          if(res&&res.id){
            unref(fileList).push({...res});
          }
      });
    }
  }


  //如果不存在busid 则需要赋予一个
  if(isNullOrUnDef(unref(businessId))){
    businessId.value=GoingNewUtils.getUUChar(32);
    emits("update:busId", unref(businessId));
  }


  /**
   * 初始化附件列表
   * @param res
   */
  const initFileList=function (res:any){
    if(res&&res.records&&Array.isArray(res.records)){
      initFileRecord&&initFileRecord(res.records);
      fileList.value=res.records;
      emits('afterLoadList',res.records)
    }
  }

  /**
   * 属性附件数据
   */
  const flushFileList=function (){
    loadingFun();
    if(loadTimer){
      clearTimeout(loadTimer)
    }
    loadTimer=setTimeout(()=>{
      if(unref(imgUrl)){
        return
      }
      loadFileList(unref(businessId),(res:any)=>{
        closeLoadingFun();
        initFileList(res);
      });
    },300)
  }

  onMounted(()=>{
    loadingFun();
    nextTick(()=>{
      //查询附件
      if(unref(businessId)){
        flushFileList();
        dataUpload["businessId"] = unref(businessId);
      }
    })
  })

  watch(imgUrl,(newVal)=>{
    if(newVal){
      //如果是上传操作 则不需要追加url啊
      if(uploadFileFlag.value){
        uploadFileFlag.value=false;
        return
      }
      nextTick(()=>{
        addImgUrlToList();
      })
    }
  })
  //监听busId的变化
  watch(businessId,(newVal)=>{
    flushFileList();
    dataUpload["businessId"] = unref(businessId);
  })

  //获取当前用户的token
  const token = StorageUtils.getSessionItem("sessionId");
  const headers = {
    "Blade-Auth": `bearer ${token}`,
    Authorization: `Basic c2FiZXI6c2FiZXJfc2VjcmV0`,
    "Page-Code": GoingUtils.getPageCode(),
  };



  const loadingFun=function (){
    loadingFlag.value=true;
    setTimeout(()=>{
      loadingFlag.value=false;
    },2000)
  }
  const closeLoadingFun=function (){
    loadingFlag.value=false;
  }

  const initImportParams=function (){
    unref(importParams).forEach((propItem:any)=>{
      const {paraName,valueType,filterValue,filterSubValue}=propItem;
      dataUpload[paraName]  = `${getParamsStr({varSubParam:filterSubValue,paramValType: valueType, paramVal: filterValue})}`
    })
  }
  /**
   * 初始化importParams参数信息
   */
  if(unref(importParams)){
    initImportParams();
  }

  watch(importParams,()=>{
    initImportParams();
  })

  const initParams=function (){
    Object.keys(unref(params)).forEach((proName)=>{
      dataUpload[proName]  = unref(params)[proName]
    })
  }
  /**
   * 初始化importParams参数信息
   */
  if(unref(params)){
    initParams();
  }

  watch(params,()=>{
    initParams();
  })

  return {
    uploadFileFlag,
    indicator,
    loadingFlag,
    loadingFun,
    closeLoadingFun,
    flushFileList,
    uploadAction: (unref(uploadAction)&&(unref(uploadAction)+'').length>0)?unref(uploadAction):ref("/api/pe-attachment/attachment/upload"),
    headers,
    dataUpload,
    fileList
  }
}
